import { GoogleMapsLink } from '../../../components/common/google-maps-link.tsx';
import { EmptyText } from '../../../components/typography/empty-text.tsx';
import { cn } from '../../../lib/utils.ts';
import type { Address } from '../../../server/types/grid-expanded-types.ts';

type Props = {
    address?: Address;
    className?: string;
};

export const GridAddressBlock: React.FC<Props> = ({ address, className = '' }) => {
    if (!address || (!address.line1 && !address.street && !address.zip)) {
        return <EmptyText />;
    }
    const country = address.country ?? '';
    return (
        <div className={cn('flex items-start gap-2', className)}>
            <div className="flex flex-col flex-1">
                <span>{address.line1}</span>
                <span>{address.street}</span>
                <span>{`${address.zip ?? ''} ${address.city ?? ''} ${country}`}</span>
            </div>
            <GoogleMapsLink address={address} className="shrink-0 mt-0.5" />
        </div>
    );
};
